import React, { useMemo } from 'react'
import styled from 'styled-components'
import SearchableSelect from 'components/SearchableSelect'
import { hideEmail } from 'utils/user'

const ApproverPicker = ({ value = [], onChange, colleagues = [], ariaLabel = 'Choose approvers', disabled = false }) => {
  const options = useMemo(() => {
    const toOption = (c, group) => ({
      value: c.id,
      label: c.name,
      sublabel: `${hideEmail(c.email || null)}${c.isSuperAdmin ? ' · Super Admin' : c.isAdmin ? ' · Admin' : ''}`,
      group,
    })
    const supers = colleagues.filter(c => c.isSuperAdmin).map(c => toOption(c, 'Super Admins'))
    const others = colleagues.filter(c => !c.isSuperAdmin).map(c => toOption(c, 'Other colleagues'))
    return [...supers, ...others]
  }, [colleagues])

  const chosen = value.map(id => colleagues.find(c => String(c.id) === String(id))).filter(Boolean)

  return (
    <Wrap>
      <SearchableSelect
        multiple
        ariaLabel={ariaLabel}
        placeholder='Super Admins (default)'
        searchPlaceholder='Search by name or email'
        value={value}
        options={options}
        onChange={onChange}
        disabled={disabled}
      />
      {chosen.length > 0 && (
        <Chosen>
          {chosen.map(c => (
            <Pill key={c.id}>
              <span>{c.name}</span>
              <RemoveButton type='button' aria-label={`Remove ${c.name}`} disabled={disabled} onClick={() => onChange(value.filter(id => String(id) !== String(c.id)))}>
                Remove
              </RemoveButton>
            </Pill>
          ))}
        </Chosen>
      )}
    </Wrap>
  )
}

export default ApproverPicker

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Chosen = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 0 4px 0 14px;
  border: 1px solid #e4e4e7;
  border-radius: 999px;
  font-size: 15px;
  color: #0c1229;
`

const RemoveButton = styled.button`
  min-height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 999px;
  background: #f4f4f5;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  color: #4d4d56;
  cursor: pointer;

  &:hover { background: #e4e4e7; }
`
